<div class="grid-process-column" *ngIf="currentState$ | async as currentState">
  <engine-process-current-state
    [processState]="currentState"
    (executeProcessTransition)="executeTransition($event)"></engine-process-current-state>
</div>
